import React from 'react';
import { Stars } from '../customer-reviews/Stars';
import { IAsset } from '../../interface/apiServiceInterface';
import { GreenStars } from '../customer-reviews/GreenStars';

export interface ReviewProps {
  name: string;
  review: string;
  image: IAsset;
  hideImage: boolean;
  hideVerifiedReview: boolean;
  starRating: boolean;
  currentDeviceType: string;
  maxWidth: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  height: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  isGreenStar?: boolean;
}

export const Review: React.FC<ReviewProps> = ({
  name,
  review,
  height,
  maxWidth,
  image,
  hideImage,
  hideVerifiedReview,
  starRating,
  currentDeviceType,
  isGreenStar = false,
}) => {
  return (
    <>
      <div className="flex items-start">
        {!hideImage && (
          <img
            style={{
              maxWidth: isNaN(+maxWidth[currentDeviceType])
                ? maxWidth[currentDeviceType]
                : +maxWidth[currentDeviceType],
              height: isNaN(+height[currentDeviceType])
                ? height[currentDeviceType]
                : +height[currentDeviceType],
            }}
            alt="img"
            className="rounded-full"
            src={`${image?.imageUrl ? process.env.REACT_APP_S3_BUCKET_URL + image?.imageUrl : 'https://t4.ftcdn.net/jpg/05/11/55/91/360_F_511559113_UTxNAE1EP40z1qZ8hIzGNrB0LwqwjruK.jpg'}`}
            decoding="async"
          />
        )}

        <div className="ml-2 flex flex-col">
          <div
            className={`flex ${starRating ? 'items-center order-first' : 'order-last'} pt-2 items-center`}>
            {isGreenStar ? <GreenStars /> : <Stars />}
            <div className="ml-2" dangerouslySetInnerHTML={{ __html: name }} />
          </div>
          {!hideVerifiedReview && (
            <div className="flex items-center">
              <span className="mr-1">✔︎</span>
              <div className="font-bold text-sm">VERIFIED BUYER</div>
            </div>
          )}
          <dt className="break-word" style={{ textAlign: 'initial' }}>
            <div dangerouslySetInnerHTML={{ __html: review }} />
          </dt>
        </div>
      </div>
    </>
  );
};
